import React from 'react';
import Icon from './Icon';

interface LoadErrorProps {
  /** What the page shows, e.g. 'order': "Couldn't load this order". */
  noun: string;
  error: string | null;
  onRetry: () => void;
  backLabel: string;
  onBack: () => void;
}

/**
 * Shown when a detail page has nothing to display. A missing item is not a
 * failure: old links and notifications can point at something since deleted, so
 * that gets a plain message with no "Try again", which could never work.
 */
const LoadError: React.FC<LoadErrorProps> = ({ noun, error, onRetry, backLabel, onBack }) => {
  const gone = !error || /not found/i.test(error);
  const color = gone ? 'var(--g500)' : 'var(--red)';

  return (
    <div className="card p-6 max-w-[520px]">
      <div className="flex items-center gap-2 mb-2" style={{ color }}>
        <Icon name="x-circle" size={18} color={color} />
        <strong>{gone ? `This ${noun} no longer exists` : `Couldn't load this ${noun}`}</strong>
      </div>
      <div className="text-sm text-g600 mb-4">{gone ? 'It may have been deleted.' : error}</div>
      <div className="flex gap-2">
        {!gone && (
          <button className="btn btn-secondary btn-sm" onClick={onRetry}>
            Try again
          </button>
        )}
        <button className={`btn btn-sm ${gone ? 'btn-secondary' : 'btn-ghost'}`} onClick={onBack}>
          {backLabel}
        </button>
      </div>
    </div>
  );
};

export default LoadError;
